import './global.scss';
import ResponsiveVideo from '@/modules/responsive-video'

document.addEventListener('DOMContentLoaded',()=>{
    let body = document.querySelector("body");
    let header = document.querySelector(".js-main-header");
    let menu = document.querySelector(".js-menu-icons");
    let menu_open = document.querySelector(".js-menu-open");
    let menu_close = document.querySelector(".js-menu-close");
    let menu_holder = document.querySelectorAll(".js-menu-holder");
    let all_scrolls = document.querySelectorAll(".js-scroll");
    let videoHolders = document.querySelectorAll(".js-video-holder");

    checkWindowScroll();

    if(menu) {
        menu_open.addEventListener('click',()=>{
            menu.classList.remove("closed");
            header.classList.remove("closed");
            body.classList.add("hide-scroll");
        });
        menu_close.addEventListener('click',()=>{
            menu.classList.add("closed");
            header.classList.add("closed");
            body.classList.remove("hide-scroll");
        });
    }
    window.addEventListener('scroll', ()=>{
        checkWindowScroll();
    });

    if(menu_holder.length > 0) {
        menu_holder.forEach((ele)=>{
            ele.addEventListener('click',()=>{
                if(!ele.classList.contains("show")) {
                    menu_holder.forEach((ele1)=>{
                        ele1.classList.remove("show");
                        ele1.querySelector(".js-menu-toggle .navigation-list__toggle").innerHTML = "+";
                        ele1.querySelector(".js-menu").style.height = "0px";
                    });
                    ele.querySelector(".js-menu-toggle .navigation-list__toggle").innerHTML = "-";
                    ele.classList.add("show");
                    let allElements = ele.querySelectorAll(".js-menu .navigation-list__sub-menu__item");
                    let totalHeight = 0;
                    allElements.forEach((ele2)=>{
                        totalHeight += ele2.offsetHeight;
                        totalHeight += 4;
                    });
                    if(allElements.length > 0) {
                        ele.querySelector(".js-menu").style.height = totalHeight+'px';
                    }
                }
                else {
                    ele.querySelector(".js-menu-toggle .navigation-list__toggle").innerHTML = "+";
                    ele.classList.remove("show");
                    ele.querySelector(".js-menu").style.height = "0px";
                }
            });
        });
    }

    if(all_scrolls.length > 0) {
        all_scrolls.forEach((ele)=>{
            ele.addEventListener('click',()=>{
                document.querySelector(`.${ele.dataset.scrollTo}`).scrollIntoView({ 
                    behavior: 'smooth'
                });
            });
        });
    }

    const videos = document.querySelectorAll('.js-responsive-video')
    Array.from(videos).forEach(el => new ResponsiveVideo(el));

    if(videoHolders.length > 0) {
        videoHolders.forEach((ele)=>{
            ele.querySelector(".js-play-button").addEventListener('click',()=>{
                if(ele.classList.contains("play")){
                    ele.querySelector(".js-play-button").innerHTML = "Play";
                    ele.classList.remove("play");
                    ele.querySelector("video").pause();
                }
                else{
                    ele.querySelector(".js-play-button").innerHTML = "Pause";
                    ele.classList.add("play");
                    ele.querySelector("video").play();
                }
            });
        });
    }

    function checkWindowScroll() {
        if(window.scrollY > 0) {
            body.querySelector(".main-header").classList.remove("no-background");
        }
        else {
            body.querySelector(".main-header").classList.add("no-background");
        }
    }
});